<template>
    <div class="row">
        <div class="col-md-5">
            <h3>Фильтры</h3>
            <label>Район</label>
            <div class="form-group">
                <select class="form-control" v-model="atefilter"> 
                    <option value="">Все</option>
                    <option v-for="ate in json.atelist" :key="ate.id" :value="ate.id">{{ate.name}}</option>
                </select>
            </div>
            <div v-if="atefilter != ''">
                <label>Школа</label>
                <div class="form-group">
                    <select class="form-control" v-model="schoolfilter"> 
                        <option value="">Все</option>
                        <option v-for="school in json.ate[atefilter].schools" :key="school.id" :value="school.id">{{school.name}}</option>
                    </select>
                </div>
            </div>
            <label>Не заполнено</label>
            <div class="form-group">
                <input type='checkbox'>
            </div>
            <label>Заполнено</label>
            <div class="form-group">
                <input type='checkbox'>
            </div>
        </div>
        <div class="col-md-12">
            <table class="table">
                <tr>
                    <th>Район</th>
                    <th>Школа</th>
                    <th>Кол-во фото</th>
                    <th>Очное посещение</th>
                    <th>Экспертная анкета заполнена</th>
                    <th>ФИО и телефон координатора</th>
                    <th>Актуализация</th>
                    <th>Выборка</th>
                    <th></th>
                </tr>
                <template v-for="ate in json.ate">
                    <tr v-for="school in ate.schools" :key="school.id">
                        <td>{{ate.name}}</td>
                        <td>{{school.name}}</td>
                        <td>{{school.option1}}</td>
                        <td>{{school.option2}}</td>
                        <td>{{school.option3}}</td>
                        <td v-html="school.option4"></td>
                        <td>{{school.option5}}</td>
                        <td>{{school.option6}}</td>
                        <td><a :href="'/cae/'+school.id">Анкета</a></td>
                    </tr>                
                </template>
            </table>
        </div>
    </div>
</template>
<script>
//import json from '../../../assets/Fotocheck.json'
import axios from 'axios'
import nprogress from 'nprogress';

export default {
    created: function(){
        this.getJson();
    },
    methods: {
        getJson: function(){

            nprogress.start();
            axios({
        url: "http://eduqa.egechita.ru/back/getcultureexperttable",
        withCredentials: true,
      }).then(Response => {
                this.get = Response.data;
                nprogress.done();
            });
        }
    },
    computed:{
        json: function(){
            var buffer = JSON.parse(JSON.stringify(this.get))
            if(this.atefilter != ""){
                for(var i in buffer.ate){
                    if(buffer.ate[i].id != this.atefilter)
                        delete(buffer.ate[i]);
                }
            }
            if(this.schoolfilter != ""){
                for(var i in buffer.ate[this.atefilter].schools){
                    if(buffer.ate[this.atefilter].schools[i].id != this.schoolfilter)
                        delete(buffer.ate[this.atefilter].schools[i]);
                }
            }
            return buffer;
        }
    },
    data(){
        return {
            atefilter: "",
            schoolfilter: "",
            get: ""
        }
    }
}
</script>
<style scoped>

</style>
